import { Card, Grid, Typography, TextField, InputAdornment, IconButton, Box, Modal, Tooltip, useMediaQuery, Button } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { AppButton } from '../../../Components/AppButton';
import { useStyles } from '../styles';
import KenColors from '../../../Helpers/Themes/kenColors';
import pdfImg from '../../../Assets/pdfimg.png';
import EditIcon from '@mui/icons-material/Edit';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { deleteResume, getJobsResume, postJobsApply, postJobUploadResume } from '../../../Utils/apiService';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Utils/routes';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import { enqueueSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import KenLoader from '../../../GlobalComponents/KenLoader';
import DeleteIcon from '@mui/icons-material/Delete';
import { set } from 'lodash';
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {
    xs: '352px',
    sm: '500px',
  },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ResumeCard = (props: any) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(location.search);
  const isOpen = params.get('open') === 'true';
  const {
    state: { user },
  } = useContext(AuthContext);
  const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:1025px)');
  
  const userData = user as AuthUser;
  const [searchValue, setSearchValue] = useState('');
  const [resumeDataDetails, setResumeDataDetails] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    const newParams = new URLSearchParams(location.search);
    newParams.delete('open'); // Remove 'open' parameter
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  };
  const [selectedFile, setSelectedFile] = useState<File | any>(null);
  const [fileName, setFileName] = useState<string>('');
  console.log(fileName, "fileNamefileNamefileName");

  const inputFileRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);
  const [base64String, setBase64String] = useState<string | null>(null);
  console.log(fileName, base64String, "base64Stringbase64String");
  const handleFileChangeDrop = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const handleButtonClickDrop = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleButtonClick = () => {
    inputFileRef.current?.click();
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const allowedExtensions = ['pdf'];
      const maxSizeInMB = 3;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (allowedExtensions.includes(fileExtension || '')) {
        if (file.size <= maxSizeInBytes) {
          setSelectedFile(file);
          setFileName(file.name);
          setError(null);

          // Convert file to base64
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result as string;
            const format = base64.split(',');
            console.log(format, "formatformatformat");

            setBase64String(format[1]);
          };
          reader.onerror = (error) => {
            setError('Error reading file');
            console.error('Error converting file to base64:', error);
          };

          reader.readAsDataURL(file);
        } else {
          setError(`File size exceeds ${maxSizeInMB} MB limit.`);
          setSelectedFile(null);
          setFileName('');
        }
      } else {
        setError('Please upload a PDF');
        setSelectedFile(null);
        setFileName('');
      }
    }
  };
  const handleSearchClick = () => {
    console.log('Search button clicked with value:', searchValue);
  };

  const applyForJob = () => {
    // debugger
    setLoading(true);
    const payLoad: any = {
      contactId: userData.applicantId,
      base64Data: base64String,
      title: selectedFile.name,
    };
    postJobUploadResume(payLoad)
      .then((res) => {
        console.log('res', res);
        if (res?.data?.success == true) {
          navigate(routes.jobs);
          enqueueSnackbar({ message: 'Resume upload Sucessfully', variant: 'success', autoHideDuration: 1000 });
          setLoading(false);
        } else if (res?.data?.success == false) {
          enqueueSnackbar({ message: res.data.message, variant: 'error', autoHideDuration: 1000 });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        setLoading(false);
      });
  };
  const getResumeData = (): Promise<void> => {
    setLoading(true);
    return getJobsResume(userData.applicantId)
      .then((res) => {
        console.log('res68764', res);
        setResumeDataDetails(res.data.contactsWithFiles?.[0]?.files || []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false); // Stop loader only after everything is complete
      });
  };
  useEffect(() => {
    setLoading(true); // Start loader
    getResumeData(); // Ensure loader stops after fetching
    setOpen(isOpen);
  }, []);
  const handleDownload = (title: any, pdf: any) => {
    // Replace with your Base64 encoded PDF string
    const base64Data = pdf;
    const fileName = title;

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };
  const filteredResumes = resumeDataDetails.filter((val: any) =>
    val.title.toLowerCase().includes(searchValue.toLowerCase())
  );
  const handleDeleteResume = (documentId: any) => {
    setLoading(true);
    const payload = {
      contactId: userData.applicantId,
      documentId: documentId,
    };
    deleteResume(payload)
      .then((res) => {
        console.log('Resume deleted successfully:', res);
        if (res?.data?.success === true) {
          getResumeData();
          enqueueSnackbar({ message: 'Resume deleted successfully', variant: 'success', autoHideDuration: 1000 });
        } else {
          enqueueSnackbar({ message: res?.data?.message || 'Failed to delete resume', variant: 'error', autoHideDuration: 1000 });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Error deleting resume:', err);
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      });
  };
  return (
    <div>
      {loading && <KenLoader />}
      <Card
        sx={{
          mt: 1,
          boxShadow: 'none !important',
          borderRadius: '9px',
          p: 3,
          height: isMobile ? '100%' : 'calc(100vh - 150px)',
          display: 'flex',
          flexDirection: 'column',
         
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Typography
              sx={{
                textAlign: 'left',
                fontWeight: 500,
                fontSize: '15px',
                mt: 2,
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '12px',
                },
              }}
            >
              Your resumes
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: { xs: 'start', sm: 'start', md: 'start', lg: 'end', xl: 'end' } }}>
            <TextField
              variant="outlined"
              placeholder="Search..."
              value={searchValue}
              onChange={handleSearchChange}
              fullWidth
              size="small"
              sx={{
                borderRadius: '6px',
                flex: 1,
                minWidth: 0,
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                },
                '& .MuiOutlinedInput-input': {
                  padding: '0 12px',
                },
                '& .MuiOutlinedInput-input::placeholder': {
                  fontSize: '12px',
                },
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  '& .MuiOutlinedInput-root': {
                    height: '30px',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontSize: '10px',
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={handleSearchClick}>
                      <SearchIcon
                        sx={{
                          fontSize: '20px',
                          '@media (min-width: 1280px) and (max-width: 1300px)': {
                            fontSize: '15px',
                          },
                        }}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              size="small"
              variant="contained"
              color="primary"
              className={classes.postJobBtns1}
              sx={{
                display: { xs: 'none', lg: 'inline-flex' },
                whiteSpace: 'nowrap',
                height: '36px',
                padding: '0 14px !important',
              }}
              onClick={handleOpen}
            >
              Upload resume
            </Button>
          </Grid>
        </Grid>
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box sx={style}>
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '15px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px',
                    },
                  }}
                >
                  Resume <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                <CloseIcon
                  sx={{
                    cursor: 'pointer',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '15px',
                    },
                  }}
                  onClick={() => {
                    handleClose();
                    setFileName('');
                    setSelectedFile(null);
                  }}
                />
              </Grid>
            </Grid>

            <>
              <TextField
                placeholder="Upload your resume (PDF only)"
                variant="outlined"
                sx={{ mt: 3 }}
                value={fileName}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleButtonClick}>
                        <AttachFileIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
              <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleButtonClick} />
            </>
            <>
              <Button
                size="small"
                variant="contained"
                color="primary"
                fullWidth = {isMobile ? true : false}
                sx={{mt:2}}
                className={classes.postJobBtns1}
                onClick={handleButtonClick}
              >
                {selectedFile ? selectedFile.name : 'Upload Resume'}
              </Button>
              <input type="file" ref={inputFileRef} style={{ display: 'none' }} accept=".pdf, .doc, .docx" onChange={handleFileChange} />
              {error && (
                <Box mt={2} color="red">
                  <p>{error}</p>
                </Box>
              )}
            </>
            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 4 }}>
              <Button
                color="primary"

                size="small"
                variant="contained"
                className={classes.postJobBtns1}
                onClick={applyForJob}
                disabled={!selectedFile || !!error}
              >
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: "#5b4200" }}>Submit</Typography>
              </Button>
            </Box>
          </Box>
        </Modal>
        <Box sx={{ flex: 1, minHeight: 0, mt: 2, overflowY: 'auto' }} className="scrollbar-cusgray">
          <Grid
            container
            spacing={2}
            sx={{
              // height: '70vh !important',
              '@media (min-width: 1280px) and (max-width: 1300px)': {
                // height: '62vh !important',
              },
            }}
          >
            {filteredResumes.length > 0 ? (
              filteredResumes.map((val: any, index: any) => (
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <Card sx={{ backgroundColor: '#F6F8FB', p: 3, boxShadow: 'none !important', borderRadius: 3 }}>
                    <Grid container>
                      <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Box sx={{ height: '24px', width: '24px' }}>
                          <img src={pdfImg} height={'100%'} width={'100%'} />
                        </Box>
                      </Grid>
                      <Grid item xs={8} sm={8} md={8} lg={6} xl={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Tooltip title={val.title} arrow>
                            <Typography
                              sx={{
                                textAlign: 'left',
                                fontWeight: 500,
                                fontSize: '15px',
                                cursor: 'pointer',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {val.title.length > 17 ? `${val.title.substring(0, 17)}...` : val.title}
                            </Typography>
                          </Tooltip>
                        </Box>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
                          {/* <IconButton
                            size="small"
                            onClick={() => navigate(routes.resumeBuilder)}
                            sx={{ padding: '4px' }}
                          >
                            <EditIcon
                              sx={{
                                fontSize: '16px',
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '15px',
                                },
                              }}
                            />
                          </IconButton> */}
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteResume(val?.contentDocumentId)}
                            sx={{ padding: '4px' }}
                          >
                            <DeleteIcon
                              sx={{
                                fontSize: '16px',
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '15px',
                                },
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                    <hr style={{ border: '1px solid #8C8E94', marginTop: 15 }} />
                    <Grid container sx={{ mt: 2 }}>
                      <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                        <Typography
                          sx={{
                            textAlign: 'left',
                            fontWeight: 500,
                            fontSize: '15px',
                            '@media (min-width: 1280px) and (max-width: 1300px)': {
                              fontSize: '10px !important',
                            },
                          }}
                        >
                          Download resume
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ display: 'flex', justifyContent: 'end' }}>
                        <FileDownloadOutlinedIcon
                          sx={{
                            fontSize: '15px',
                            cursor: 'pointer',
                            '@media (min-width: 1280px) and (max-width: 1300px)': {
                              fontSize: '12px',
                            },
                          }}
                          onClick={() => handleDownload(val.title, val.base64Data)}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                // );
              ))
            ) : (
              <Typography sx={{ textAlign: 'center', width: '100%', marginTop: 2 }}>
                No results found.
              </Typography>
            )}
          </Grid>
        </Box>
        <Box sx={{ mt: 2, display: { xs: 'flex', lg: 'none' }, justifyContent: { xs: 'stretch', sm: 'flex-end' } }}>
          <Button
            size="small"
            variant="contained"
            color='primary'
            className={classes.postJobBtns1}
          fullWidth={isMobile ? true : false}
            onClick={handleOpen}
      >
              Upload resume
          </Button>
        </Box>
      </Card>
    </div>
  );
};

export default ResumeCard;
